export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED'
export const MFA_SETUP = 'MFA_SETUP'
export const SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA'
export const SMS_MFA = "SMS_MFA"
